import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'svgIconNameInNamespaceByUrl', standalone: true })
export class SvgIconNameInNamespaceByUrlPipe implements PipeTransform {
  transform(url: string, namespace?: string): string {
    const match = url.match(/\/([^/]+)\.svg$/);
    const svgIconName = match?.[1] ?? '';

    return namespace ? `${namespace}:${svgIconName}` : svgIconName;
  }
}
